"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "@/src/hooks/usePathname";
import { getBridge } from "@/src/lib/bridge/bridge";
import { isInNativeDetailShell } from "@/src/lib/bridge/shellAppNavigation";
import { shouldDisableDetailGestureBack } from "@utils/bridge/detailGestureBackPolicy";

/**
 * Detail 内 SPA 路由变化时，同步原生手势 / 系统返回策略（消息：container-control / set-detail-gesture-back）。
 */
export function useDetailGestureBackSync(): void {
  const pathname = usePathname();
  const lastSentEnabledRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (!getBridge().isInApp()) {
      return;
    }
    if (!isInNativeDetailShell()) {
      // 离开 Detail 后清缓存，避免再次进入同 pathname 时因值未变而漏同步原生默认态
      lastSentEnabledRef.current = null;
      return;
    }

    const enabled = !shouldDisableDetailGestureBack(pathname);
    if (lastSentEnabledRef.current === enabled) {
      return;
    }

    lastSentEnabledRef.current = enabled;
    getBridge().setDetailGestureBack(enabled);
  }, [pathname]);
}
